module.exports = __webpack_public_path__ + "img/img3.903f9180.jpg";